import client from '@/api/base';

export default {
  async INGLogin(data) {
    const response = await client.post('/local-login/', data);
    return response;
  },

  async updateINGUser(data) {
    const response = await client.patch('/account/current-user/', data);
    return response;
  },

  async updateINGPassword(data) {
    const response = await client.patch('/local-user/password/', data);
    return response;
  },
};
